import * as React from 'react';

export function createCtx<A extends any | null>({
  throwIfMissingProvider = true,
}: {
  throwIfMissingProvider?: boolean;
} = {}) {
  const ctx = React.createContext<A | undefined>(undefined);

  function useCtx({ innerThrowIfMissingProvider }: { innerThrowIfMissingProvider?: boolean } = {}) {
    const c = React.useContext(ctx);

    if (c === undefined && throwIfMissingProvider && innerThrowIfMissingProvider !== false) {
      throw new Error('useCtx must be inside a Provider with a value');
    }

    return c;
  }

  return [
    useCtx as (props?: { innerThrowIfMissingProvider?: boolean }) => A,
    ctx.Provider,
    ctx.Consumer,
  ] as const;
}
